import React from 'react'
import { get, values, capitalize  } from 'lodash'
import Group from './group'
import IdSelector from '../../common/id-selector'
import RESOURCE_TYPES from '../../../constants/resource-types'

const Title = ({
    value = {},
    onChange = () => {}
}) => {
    const items = values(RESOURCE_TYPES).map(type => ({ id: type, name: capitalize(type) }))
    return (
        <React.Fragment>
            <Group label='Resource Type'>
                <IdSelector
                    items={items}
                    value={get(value, 'type', '') || ''}
                    onChange={type => onChange({ ...value, type})}
                    placeholder='Select Type'
                />
            </Group>
        </React.Fragment>
    )
}

export default Title